export const CREATE_EXHIBITOR_REVIEW = `
  mutation createExhibitorReview($input: CreateExhibitorReviewInput!, $tenant_id: Int!) {
    createExhibitorReview(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ExhibitorReview {
        id
        exhibitor_id
        chair_reviewer_id
        meeting_id
        review
        review_date
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
